module.exports = __webpack_public_path__ + "static/media/balk_afm1.b762420d.jpg";